import Aos from 'aos'
import React from 'react'



export default function SingleProductFeatures() {
    return (
        <div data-aos='fade-down' data-aos-anchor-placement="top-center">
            <section class="py-6">
    <div class="container">
        <div class="row">
            <div class="col-md-8 mx-auto">
                <h2 class="text-center text-md-left">What? Why? We? <span class="text-success">How?</span></h2>
                <div class="row feature-grid">
                    <div class="col-sm-6">
                        <div class="media">
                            <div class="icon-box">
                                <div class="icon-box-inner">
                                    <span data-feather="check-circle" width="28" height="28"></span>
                                </div>
                            </div>
                            <div class="media-body" >

                                 Smooth and Clean
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="media">
                            <div class="icon-box">
                                <div class="icon-box-inner">
                                    <span data-feather="command" width="28" height="28"></span>
                                </div>
                            </div>
                            <div class="media-body">
                                Highly Intuitive
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="media">
                            <div class="icon-box">
                                <div class="icon-box-inner">
                                    <span data-feather="feather" width="28" height="28"></span>
                                </div>
                            </div>
                            <div class="media-body">
                                Light as a Feather
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="media">
                            <div class="icon-box">
                                <div class="icon-box-inner">
                                    <span data-feather="zap" width="28" height="28"></span>
                                </div>
                            </div>
                            <div class="media-body">
                                Sweet and Simple
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="media">
                            <div class="icon-box">
                                <div class="icon-box-inner">
                                    <span data-feather="git-pull-request" width="28" height="28"></span>
                                </div>
                            </div>
                            <div class="media-body">
                                No Authentication Required
                            </div>
                        </div>
                    </div><div class="col-sm-6">
                        <div class="media">
                            <div class="icon-box">
                                <div class="icon-box-inner">
                                    <span data-feather="droplet" width="28" height="28"></span>
                                </div>
                            </div>
                            <div class="media-body">
                                Easy Transactions
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
        </div>
    )
}
